import { Snackbar, Alert } from '@mui/material';
import { useState, useEffect } from 'react';

export default function NotificationToast({ notification }) {
  const [open, setOpen] = useState(false);

  // افتح الـ Snackbar كل مرة يوصل إشعار جديد
  useEffect(() => {
    if (notification) {
      setOpen(true);
    }
  }, [notification]);

  const handleClose = (_, reason) => {
    if (reason === 'clickaway') return;
    setOpen(false);
  };

  return (
    <Snackbar
      open={open}
      autoHideDuration={7000}
      onClose={handleClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right'  }}
    >
      <Alert
        onClose={handleClose}
        severity="info"
        sx={{ width: '100%' }}
      >
        <strong>{notification?.title}</strong> — {notification?.body || notification?.message}
      </Alert>
    </Snackbar>
  );
}
